var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',_vm._b({attrs:{"value":_vm.show}},'v-overlay',_vm.$attrs,false),[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"64"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }